import React, { useEffect, useState } from "react";
import useAuth from "../Hooks/useAuth";
import "../css/invoice.css";
import AlertField from "./AlertField";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const InvoiceModal = (props) => {
  const { auth } = useAuth();
  const data = props.data;
  const [alert, setAlert] = useState();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    showAlert(props.message, props.type);
  }, []);

  const download = () => {
    //gets the modal form by its id
    const input = document.getElementById("invoiceModal");

    //generates the pdf file
    html2canvas(input).then((canvas) => {
      //converts modal forms to image
      const imgData = canvas.toDataURL("image/png");
      //creates instance of jsPDF
      const pdf = new jsPDF();
      //adds text and image to the pdf file
      pdf.text("Iswar Medical Hall", 80, 10);
      pdf.text("Invoice Detail", 88, 20);
      pdf.addImage(imgData, "JPEG", 40, 40);
      pdf.setFontSize("9");
      pdf.text("* Thank you for choosing Iswar Medical Hall.", 75, 200);
      //saves the pdf file
      pdf.save(`Invoice-${data?.invoice_id}`);
    });
  };
  return (
    <>
      <button
        type="button"
        id="invoiceButton"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      ></button>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Invoice
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <AlertField alert={alert} />

            <div className="modal-body" id="invoiceModal">
              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>Invoice ID:</h6>
                  <p>{data?.invoice_id}</p>
                </div>
                <div className="col-md-6">
                  <h6>Appointment ID:</h6>
                  <p>{data?.appointment_id}</p>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>Payment Time:</h6>
                  <p>{data?.payment_time?.replace("T", " ")}</p>
                </div>
                <div className="col-md-6">
                  <h6>Reason for Visit:</h6>
                  <p>{data?.reason}</p>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>Appointment Date:</h6>
                  <p>{data?.appointment_date}</p>
                </div>
                <div className="col-md-6">
                  <h6>Appointment Time:</h6>
                  <p>{data?.appointment_time}</p>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>Doctor Name:</h6>
                  <p>{data?.doctor_name}</p>
                </div>
                <div className="col-md-6">
                  <h6>Patient Name:</h6>
                  <p>{data?.patient_name}</p>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>Fees:</h6>
                  <p>{data?.fees}</p>
                </div>
                <div className="col-md-6">
                  <h6>Payment Type:</h6>
                  <p>{data?.payment_type}</p>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  {auth?.user.roles === 0 &&
                    data?.payment_type !== "Manual" && (
                      <>
                        <h6>PIDX:</h6>
                        <p>{data?.pidx}</p>
                      </>
                    )}
                </div>

                <div className="col-md-6 text-center">
                  {data?.cleared ? (
                    <div className="stamp stamp-success m-0">
                      <h3 className="m-1 p-0">Paid</h3>
                    </div>
                  ) : (
                    <div className="stamp stamp-danger m-0">
                      <h3 className="m-1 p-0">Left</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={download}>
                <i className="fa-solid fs-4 fa-file-pdf me-2"></i>Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceModal;
